import React, { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { createStackNavigator } from "@react-navigation/stack";
import { useTheme } from "@react-navigation/native";
import SignInScreen from '../../screens/SessionScreens/SignInScreen/SignInScreen';
import { useSettings } from '../../hooks/useSettings';
import SignInScreen2FA from '../../screens/SessionScreens/SignInScreen2FA/SignInScreen2FA';
import SignUpScreen from '../../screens/SessionScreens/SignUpScreen/SignUpScreen';
import AsyncStorage from '@react-native-async-storage/async-storage';

const Stack = createStackNavigator();

// Stack Navigation for the login screens 

const StackNavigation = () => {
    const { colors } = useTheme();
    const { isWinAuth } = useSettings();
    // AsyncStorage.clear(); 
    const [winAuth, setWinAuth] = useState(undefined);
    const [api, setApi] = useState('');
    useEffect(() => {
        //! IF debug is true then bypass the registration process and hardcode the API to use. 
        if (process.env.DEBUG === 'true') {
            let customApiDebugUrl = "";
            if (Platform.OS === 'web') {
                //* UNCOMMENT DEPENDING ON CLIENT *//
                // * For WEB localhost
                customApiDebugUrl = process.env.REACT_APP_API_URL;
                //customApiDebugUrl = 'http://localhost:3000/';
                // customApiDebugUrl = 'https://oap.pascal.ac.cy/OasysCoreApi/';
                // customApiDebugUrl = 'https://devhrm.unic.ac.cy:8443/OasysCoreApi/';
            }
            else if (Platform.OS === 'android') {
                // * For Android Emulator
                customApiDebugUrl = 'http://10.0.2.2:43752/';
            }
            else {
                // * For MAC localhost
                customApiDebugUrl = 'http://localhost:43752/';
            }
            // console.log(customApiDebugUrl)
            AsyncStorage.removeItem("client_api");
            AsyncStorage.setItem(
                "client_api",
                JSON.stringify({
                    clientApi: customApiDebugUrl,
                }));
            isWinAuth(customApiDebugUrl).then((resp) => {
                setWinAuth(resp)
            })
        };

        //* If Client Api is set ther show the Sign In screen otherwise show the sign up screen
        AsyncStorage.getItem('client_api').then((response) => {
            if (response !== undefined && response !== null) {
                setApi(JSON.parse(response).clientApi)
            }
        });

    }, [])
    return (
        <>
            <Stack.Navigator
                screenOptions={{
                    headerShown: false,
                    headerTitle: '',
                    headerStyle: { backgroundColor: colors.background_header },
                    headerTintColor: colors.text_primary,
                    headerTitleStyle: { fontWeight: 'bold' },
                    headerTitleAlign: 'center',
                    headerBackTitleVisible: false,
                }}
            >
                {api !== '' ? winAuth ? <Stack.Screen
                    name="SignInScreen2FA"
                    component={SignInScreen2FA}
                /> : <Stack.Screen
                    name="SignInScreen"
                    component={SignInScreen}
                /> :
                    <Stack.Screen name="SignUpScreen" component={SignUpScreen} />}
                {/* Not needed because Oasys will already have users */}
                {/*<Stack.Screen name="ConfirmEmailScreen" component={ConfirmEmailScreen} />
            <Stack.Screen name="ForgotPasswordScreen" component={ForgotPasswordScreen} />
            <Stack.Screen name="ResetPasswordScreen" component={ResetPasswordScreen} /> */}
            </Stack.Navigator>
        </>
    );
}

export default StackNavigation;